module.exports = __webpack_public_path__ + "img/subAra6.1d0e5aa9.jpg";